import Vue from "vue";
import VueRouter from "vue-router";

// Routes
import { canNavigate } from "@/libs/acl/routeProtection";
import {
  isUserLoggedIn,
  getUserData,
  getHomeRouteForLoggedInUser,
  isTwoFactorEnabled,
  isTwoFactorVerified,
} from "@/auth/utils";
import dashboard from "./routes/dashboard";
import pages from "./routes/pages";
import profiles from "./routes/profiles";
import users from "./routes/users";
import coupons from "./routes/coupons";
import op from "./routes/op";
import pa from "./routes/pa";
import parkingFee from "./routes/parking-fee";
import auditTrail from "./routes/audit-trail";
import reports from "./routes/reports";
import Http from "@/libs/axios";

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    { path: "/", redirect: { name: "dashboard-analytics" } },
    ...pages,
    ...dashboard,
    ...profiles,
    ...users,
    ...coupons,
    ...op,
    ...parkingFee,
    ...pa,
    ...auditTrail,
    ...reports,
    {
      path: "*",
      redirect: "error-404",
    },
  ],
});

router.beforeEach((to, from, next) => {
  const isLoggedIn = isUserLoggedIn();
  const twoFactorEnabled = isTwoFactorEnabled();
  const twoFactorVerified = isTwoFactorVerified();

  if (
    isLoggedIn &&
    !twoFactorEnabled &&
    from.name !== "2fa-enable" &&
    to.name !== "2fa-enable"
  ) {
    return next({ name: "2fa-enable" });
  } else if (isLoggedIn && !twoFactorEnabled && to.name === "2fa-enable") {
    return next();
  }

  if (
    isLoggedIn &&
    !twoFactorVerified &&
    from.name !== "2fa-verify" &&
    to.name !== "2fa-verify"
  ) {
    return next({ name: "2fa-verify" });
  } else if (isLoggedIn && !twoFactorVerified && to.name === "2fa-verify") {
    return next();
  }

  // If 2fa is verified and 2fa is not enabled, remove twoFactorVerified from localStorage
  if (isLoggedIn && twoFactorVerified && !twoFactorEnabled) {
    // Remove twoFactorVerified from localStorage
    localStorage.removeItem("twoFactorVerified");
    return next({ name: "auth-login" });
  }

  let isUserAuthorized = isLoggedIn && twoFactorVerified;

  if (!canNavigate(to)) {
    // Redirect to login if not logged in
    if (!isUserAuthorized) return next({ name: "auth-login" });

    // If logged in => not authorized
    return next({ name: "misc-not-authorized" });
  }

  // Redirect if logged in
  if (to.meta.redirectIfLoggedIn && isUserAuthorized) {
    const userData = getUserData();
    next(getHomeRouteForLoggedInUser(userData ? userData.role : null));
  }

  if (to.query.hasOwnProperty("read")) {
    if (to.query.read != "") {
      Http.get(`user/mark-notification-as-read/${to.query.read}`);
    }
  }

  return next();
});

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById("loading-bg");
  if (appLoading) {
    appLoading.style.display = "none";
  }
});

export default router;
